module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("4Kg6a"))).then(() => parcelRequire('fThBo'));